import React from "react";

const RequiredLabel = ({ isRequired }) => {
  if (!isRequired) return null;
  return <span className="text-danger ms-1 text-xs">*</span>;
};

export default RequiredLabel;
